import * as React from 'react'
import ReleaseMessageToastContent from '../../components/Toast/ReleaseMessageToastContent'
import useAppToast, { TOAST_TIMEOUT_NEVER } from '../useAppToast'

/**
 * A fixed id, so a second notification updates the banner that is already on screen instead of stacking
 * another one on top of it. This used to be an empty string, which counts as "no id" and stacked.
 */
const releaseMessageToastId = 'release-message'

export default function useProcessReleaseMessageNotification() {
    const toast = useAppToast()

    return () => {
        console.log('Showing an upcoming release notification')

        toast.upsert(releaseMessageToastId, <ReleaseMessageToastContent />, { timeout: TOAST_TIMEOUT_NEVER })
    }
}
